import { Button, CircularProgress, Stack, TextField,Grid } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";
import { isValidEmail } from "../util";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const [formData,setFormData] = useState({
    username:'',
    email:null,
    password:'',
    confirmPassword:''
  });

  const [loader,setLoader]=useState(false);

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async () => {
    if(validateInput()){
    setLoader(true);
    const url = `${config.endpoint}/auth/register`;
    const {username,password,email}=formData;
    axios.post(url,{name:username,password:password,email:email} )
    .then((response) =>{
      if(response?.data?.status){
        enqueueSnackbar('Registered successfully',{variant:'success'})
        setFormData({
          username:'',
          password:'',
          confirmPassword:''
        });
        history.push('/login');
      }
      else{
        enqueueSnackbar(response?.data?.message || "Something went wrong",{variant:'error'});
      }
      setLoader(false);
    }).catch((error)=>{
      const {message}=error.response;
      enqueueSnackbar(message || 'Something went wrong. Check that the backend is running, reachable and returns valid JSON.',{variant:'error'});
      setLoader(false);
    })
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    const {username,password,confirmPassword,email}=formData;
    if(!username.trim().length > 0){
      enqueueSnackbar('Username is a required field',{variant:'warning'});
      return false;
    }

    if(username.trim().length < 4){
      enqueueSnackbar('Username must be at least 4 characters',{variant:'warning'});
      return false;
    }
    
    if(!email?.trim()){
      enqueueSnackbar('Email is a required field',{variant:'warning'});
      return false;
    }

    if(!isValidEmail(email)){
      enqueueSnackbar('Enter a valid email',{variant:'warning'});
      return false;
    }

    if(!password.trim().length > 0){
      enqueueSnackbar(' Password is a required field',{variant:'warning'});
      return false;
    }
    
    if(password.trim().length < 6){
      enqueueSnackbar('Password must be at least 6 characters',{variant:'warning'});
      return false;
    }

    if(password !== confirmPassword){
      enqueueSnackbar('Passwords do not match',{variant:'warning'});
      return false;
    }

    return true;
  };
  
  const handleInputChange =(event)=>{
   setFormData({...formData,[event.target.name]:event.target.value});
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            value={formData.username}
            onChange={(e) => handleInputChange(e)}
            fullWidth
          />
          <TextField
            id="email"
            label="Email"
            name="email"
            variant="outlined"
            placeholder="Enter Email"
            value={formData.email}
            onChange={(e) => handleInputChange(e)}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={formData.password}
            onChange={(e) => handleInputChange(e)}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={formData.confirmPassword}
            onChange={(e) => handleInputChange(e)}
          />
          {loader ? <Grid style={{display:'flex',flex:'1',justifyContent:'center',alignItems:'center'}}>
           <CircularProgress color="success"  />
           </Grid>:
           <Button className="button" variant="contained" onClick={register}>
            Register Now
           </Button>}
          <p className="secondary-action">
            Already have an account?{" "}
             <Link className="link" to="/login">
              Login here
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
